module.exports = __webpack_public_path__ + "img/block_bg_4.094b2bb9.png";